export enum BusinessType {
  GENERAL_TRANSPORT = 'GENERAL_TRANSPORT', // 通用运输
  SPIDER_WEB = 'SPIDER_WEB', // 蛛网
  SINGLE_POINT = 'SINGLE_POINT' // 单点
}

export enum TaskSource {
  AIRGROUND = 'AIRGROUND',
  TRANSPORT = 'TRANSPORT'
}

export enum ScanType {
  'waybill' = 'waybill', // 运单号
  'box' = 'box' // 箱号
}

export enum VehicleStatus {
  IDLE = 'IDLE', // 空闲中（没有任务）
  TASKING = 'TASKING', // 任务中（在起点发车之后都是任务中的状态）
  WAITING = 'WAITING', // 待发车（有任务在起点没发车行走）
  OFFLINE = 'OFFLINE' // 离线
}

export enum VehicleChargeState {
  UNKNOWN = 'UNKNOWN',
  DISCHARGING = 'DISCHARGING',
  CHARGING = 'CHARGING',
  CHARGE_OK = 'CHARGE_OK'
}

export enum VehicleChargeConnect {
  CHARGER_UNKNOWN = 'CHARGER_UNKNOWN',
  CHARGER_CONNECT = 'CHARGER_CONNECT',
  CHARGER_DISCONNECT = 'CHARGER_DISCONNECT'
}
export enum TravelStatus {
  SKIP = 'SKIP',
  INIT = 'INIT',
  START = 'START',
  ARRIVED = 'ARRIVED',
  DEPART = 'DEPART',
  STAY = 'STAY'
}
export enum StopType {
  HOME = 'HOME',
  PICKUP = 'PICKUP'
}
export const VehicleStatusText = new Map([
  [VehicleStatus.IDLE, '空闲中'],
  [VehicleStatus.TASKING, '任务中'],
  [VehicleStatus.WAITING, '待发车'],
  [VehicleStatus.OFFLINE, '离线']
]);

export enum POWER_COMMAND {
  ON = 'powerOn',
  OFF = 'powerOff'
}

export enum MapLayerEnum {
  SCHEDULED_ROUTE_LAYER = 'SCHEDULED_ROUTE_LAYER', // 调度规划线路
  FINISHED_ROUTE_LAYER = 'FINISHED_ROUTE_LAYER', // 已完成线路
  STOP_POINT_LAYER = 'STOP_POINT_LAYER', // 停靠点
  REAL_TIME_POINT_LAYER = 'REAL_TIME_POINT_LAYER', // 实时点
  ARROW_LAYER = 'ARROW_LAYER' // 路线箭头图层
}

export enum VehicleSettingType {
  EXCEPTION_CONTACT = 'EXCEPTION_CONTACT', // 异常通知
  SITE_CONTACT = 'SITE_CONTACT' // 到站通知
}

export enum ENABLED_STATUS {
  ENABLED = 1,
  DISABLED = 0
}

export enum VehicleScheduleState {
  ALREADY = 'ALREADY', // 空闲状态
  SETOUT = 'SETOUT', // 去程（在路上跑）
  DELIVERY = 'DELIVERY', // 配送中（停在停靠点进行货物交接中）
  RETURN = 'RETURN', // 回程（在路上跑）
  ARRIVED = 'ARRIVED' // 到达home点（终点）
}

export enum HandoverStatus {
  PICKUP = 'PICKUP',
  LOAD = 'LOAD',
  OVERDUE = 'OVERDUE'
}
export enum HandoverType {
  TRUST = 'TRUST', // 信任交接
  NONTRUST = 'NONTRUST' // 非信任交接
}
export enum SpiderWebPickupType {
  SCAN = 'SCAN', // 逐单扫描
  TRUST = 'TRUST' // 全部收货
}
export const HandoverTypeText = new Map([
  [HandoverType.TRUST, '已信任交接'],
  [HandoverType.NONTRUST, '逐单验货']
]);
export enum CheckDepartureErrorCode {
  NO_PACKAGE_SCANNED = 'A072040',
  PACKAGES_INCOMPLETE = 'A072049'
}
export enum SpiderWebCheckDepartureErrorCode {
  PACKAGE_SCANNED_NO_ROUTES = 'A072056',
  NO_PACKAGE_SCANNED_HAVE_ROUTES = 'A072057',
  NO_PACKAGE_SCANNED_NO_ROUTES = 'A072058'
}
export enum VEHICLE_STATE {
  GUARDIAN_EMERGENCY = 'GUARDIAN_EMERGENCY', // 安全急停
  LOCAL_CONTROL = 'LOCAL_CONTROL' // 手柄接管
}

export enum SUB_TASK_STATUS {
  CREATE = 'CREATE', // 待发车
  DELIVERY = 'DELIVERY', // 任务中
  HANDOVER = 'HANDOVER', // 交接中
  OUT_OF_STOCK = 'OUT_OF_STOCK', // 无货完成
  COMPLETE = 'COMPLETE', // 任务完成
  CANCEL = 'CANCEL' // 任务取消
}

/**
 * 通用枚举映射表key
 * 用于从get_enum_list_map接口获取对应的枚举list
 * @export
 * @enum {number}
 */
export enum CommonEnumListMapKey {
  ISSUE_FEEDBACK_TYPE_ENUM = 'ISSUE_FEEDBACK_TYPE_ENUM', // 问题反馈单标签类型枚举
  REMOTE_CONTROL_FEEDBACK_TYPE_ENUM = 'REMOTE_CONTROL_FEEDBACK_TYPE_ENUM' // 帮忙遥控类型枚举
}

/**
 * 通用数字转化成布尔值的映射表
 * 用于从后端获取数据之后需要映射成布尔值的情况
 */
export const CommonIntegerToBoolean = new Map([
  [1, true],
  [0, false]
]);

/**
 * 展示在多车页/单车页的车辆问题的状态枚举
 */
export enum VehicleIssueTypeEnum {
  STOP = 'STOP', // 停用中
  REPAIR = 'REPAIR', // 维修中
  TO_DO_CHECK = 'TO_DO_CHECK' // 待验收
}
